import { theme } from 'styles';

export function useRandomColor() {
  const colors = [theme.colors.gray600, theme.colors.mint, theme.colors.secondary300, theme.colors.primary100];
  const randomColor = () => colors[Math.floor(Math.random() * colors.length)];

  return randomColor;
}
